import React from 'react';
import { useState, useEffect } from 'react'
import Header from '../UI/Header'
import LogoDividerContainer from '../containers/LogoDividerContainer'
import { isValidUser } from '../OnlyWithFunctions'
import { useQuery } from '@tanstack/react-query'
import { getListaPratiche } from '../services/getListaPratiche'
import { getListaPraticheInAttesa } from '../services/getListaPraticheInAttesa'
import { getListaPraticheOnboardingOrMonitoraggio } from '../services/getListaPraticheOnboardingOrMonitoraggio'
import { getListaUtenzeAssegnatari } from '../services/getListaUtenzeAssegnatari'
import { StatiPratica } from '../utils/StatiPratica'
import { search } from '../services/search'
import { StyledButton } from '../UI/StyledButton'

import {
  Stack,
  Box,
  TextField,
  Grid,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Container,
} from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'

import GraficoPie from '../Charts/GraficoPie'
import GraficoPie2 from '../Charts/GraficoPie2'
import OnlyWithFunction from '../OnlyWithFunctions'

const StatistichePanel = () => {
  const theme = useTheme()
  const navigate = useNavigate()


  return (

    <div>
      <Header
        showHome={true}
        showRichiesta
        showStatistiche={false}
        header={
          <Grid
            container
            columns={{ xs: 4, sm: 8, md: 12 }}
            justifyContent="center"
            alignContent="center"
            sx={{
              textAlign: 'center',
              height: '100px', // Imposta l'altezza desiderata
            }}
          >
            <Typography
              sx={{ flexGrow: 1 }}
              xs={12}
              item
              alignItems="center"
              color={theme.palette.black.main}
              variant="h1"
            >
              STATISTICHE
            </Typography>
          </Grid>
        }
      />
      <Box sx={{marginLeft: '2vw',marginRight: '2vw'}}>
        <Grid container spacing={2} >
          <Grid item xs={12}><Typography variant="h4">Statistiche pratiche in lavorazione o annullate</Typography></Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: '#C8C8C8',
                width: '100%',
                height: '110%',
                alignItems: 'center',
              }}
            >
              <Stack direction="column" alignItems="center">
                <GraficoPie
                  colors={{ scheme: 'blue_purple' }}
                  searchPraticheChiuse={false}
                  display="flex"
                  alignItems="center"
                />
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: '#C8C8C8',
                width: '100%',
                height: '110%',
              }}
            >
              <Stack direction="column" alignItems="center">
                <GraficoPie2
                  key={"pie-aperte"}
                  colors={{ scheme: 'blues' }}
                  searchPraticheChiuse={false}
                />
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} mt={6}><Typography variant="h4">Statistiche pratiche chiuse</Typography></Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: '#C8C8C8',
                width: '100%',
                height: '110%',
              }}
            >
              <Stack direction="column" alignItems="center">
                <GraficoPie2
                  key="pie-chiuse"
                  colors={{ scheme: 'blues' }}
                  searchPraticheChiuse={true}
                />
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>





    </div>


  );
};

export default StatistichePanel;

